<template>
  <div>
    <ul v-if="errors.length">
      <li v-for="(error, index) in errors" :key="index">
        <strong>{{ error.dataPath }}</strong>
        {{ error.message }}
        {{ error.params }}
      </li>
    </ul>
    <div class="teaser-container">
      <component
        :is="`bpb-extension-${
          [
            'article',
            'blog',
            'product',
            'event',
            'media',
            'collection',
            'keyword',
            'opinion',
          ].includes(teaser.meta.extension)
            ? teaser.meta.extension
            : 'basic'
        }`"
        v-for="(teaser, index) in teaserList"
        :key="`${teaser.meta.id}-${index}`"
        :data="teaser"
      ></component>
    </div>
  </div>
</template>

<script>
import { validateTeaserList } from '@js/utils/schema-validation';

export default {
  props: {
    teaserList: {
      type: Array,
    },
  },
  data() {
    return {
      errors: [],
    };
  },
  async mounted() {
    this.validate();
  },
  methods: {
    async validate() {
      const valid = await validateTeaserList(this.teaserList);
      if (!valid) {
        console.log(validateTeaserList);
        this.errors = validateTeaserList.errors;
        console.error(this.errors);
      }
      return valid;
    },
  },
};
</script>
